export default {
  tabs: {
    access: 'Adgang',
    notification_preferences: 'Notifikationsindstillinger',
  },
  sections: {
    notification_preferences: {
      title: 'Notifikationsindstillinger',
      form: {
        has_voice_call_reminders: {
          label: 'Modtag automatiske opkald om afventende ordrer',
        },
        voice_reminders_phone_number: {
          label: 'Telefonnummer til opkald',
        },
        has_whatsapp_notifications: {
          label: 'Send notifikationer (f.eks. ordrer sat på pause) via WhatsApp',
        },
        whatsapp_phone_number: {
          label: 'WhatsApp-telefonnummer',
        },
        has_order_email_notifications: {
          label: 'Send ordrenotifikationer via e-mail',
        },
        order_notifications_email: {
          label: 'E-mailadresse til videresendelse af ordrenotifikationer',
        },
      },
    },
    voice_calls: {
      title: 'Telefonopkald',
    },
    whats_app_notifications: {
      title: 'WhatsApp-notifikationer',
    },
    order_email_notifications: {
      title: 'E-mailnotifikationer om ordrer',
    },
    access_control: {
      title: 'Adgangskontrol',
      form: {
        company_ids: {
          label: 'Kan få adgang til restauranter',
          tooltip: 'Giver adgang til følgende restauranter (ud over restauranter i samme brand)',
        },
      },
    },
  },
  buttons: {
    save: 'Gem',
  },
  toasts: {
    failed_to_save_changes: 'Ændringerne kunne ikke gemmes',
    changes_got_saved: 'Ændringerne er gemt',
  },
};
